import {view} from '@sail/ui';
import {defineMessages, useIntl} from 'react-intl';

const messages = defineMessages({
  disclaimer: {
    id: 'support_conversations_client.chatscreen.disclaimer',

    description: 'Disclaimer text for the AI assistant',

    defaultMessage: 'AI may make mistakes. Verify important information.',
  },
});

export function Disclaimer() {
  const {formatMessage} = useIntl();

  return (
    <view.div
      css={{
        marginX: 'medium',
        marginBottom: 'medium',
        stack: 'x',
        alignX: 'center',
        alignY: 'center',
        flexGrow: 0,
        color: 'form.placeholder',
        font: 'label.small',
      }}
    >
      <view.span>{formatMessage(messages.disclaimer)}</view.span>
    </view.div>
  );
}
